module.exports = __webpack_public_path__ + "try_quiz_on_web.svg?33e93cb962b283c098c9ed68d54d67aa";


//////////////////
// WEBPACK FOOTER
// ./static/try_quiz_on_web.svg
// module id = 37
// module chunks = 0